import React, { createContext, useContext, useEffect, useState } from "react";
import { translations, roleNames, expenseCategories, fmtAFN } from "@/lib/i18n";

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("rp_lang") || "dari");

  useEffect(() => {
    localStorage.setItem("rp_lang", lang);
    document.documentElement.setAttribute("lang", lang === "dari" ? "fa" : "ps");
    document.documentElement.setAttribute("dir", "rtl");
  }, [lang]);

  const t = (key) => translations[lang]?.[key] || key;
  const tr = (item, field) =>
    item?.[field + (lang === "pashto" ? "_pashto" : "_dari")] ||
    item?.[field + "_dari"] ||
    "";
  const role = (r) => roleNames[lang]?.[r] || r;
  const expCats = expenseCategories[lang];
  const money = (n) => fmtAFN(n, lang);

  return (
    <I18nCtx.Provider value={{ lang, setLang, t, tr, role, expCats, money }}>
      {children}
    </I18nCtx.Provider>
  );
}

export const useI18n = () => useContext(I18nCtx);
